import React from 'react';
import './ReadingResult.css';

const ReadingResult = ({ reading, onNewReading }) => {
  if (!reading) return null;

  // Use the English name mapping for images
  const getCardImagePath = (cardName) => {
    const nameMap = {
      'El Loco': 'fool',
      'El Mago': 'magician',
      'La Sacerdotisa': 'high-priestess',
      'La Emperatriz': 'empress',
      'El Emperador': 'emperor',
      'El Hierofante': 'hierophant',
      'Los Enamorados': 'lovers',
      'El Carro': 'chariot',
      'La Fuerza': 'strength',
      'El Ermitaño': 'hermit',
      'La Rueda de la Fortuna': 'wheel-of-fortune',
      'La Justicia': 'justice',
      'El Colgado': 'hanged-man',
      'La Muerte': 'death',
      'La Templanza': 'temperance',
      'El Diablo': 'devil',
      'La Torre': 'tower',
      'La Estrella': 'star',
      'La Luna': 'moon',
      'El Sol': 'sun',
      'El Juicio': 'judgement',
      'El Mundo': 'world'
    };
    
    const englishName = nameMap[cardName] || cardName.toLowerCase().replace(/\s+/g, '-');
    return `/images/cards/${englishName}.png`;
  };

  return (
    <div className="reading-result">
      <h2 className="reading-title">Tu Lectura de Tarot</h2>
      
      <div className="reading-content">
        <div className="reading-card">
          <div className="card-image-container">
            <img 
              src={getCardImagePath(reading.card.name)}
              alt={reading.card.name} 
              className="result-card-image" 
            />
          </div>
          <h3 className="card-name">{reading.card.name}</h3>
          <div className="keywords">
            <strong>Palabras clave:</strong> {reading.card.keywords}
          </div>
        </div>
        
        <div className="reading-interpretation">
          <div className="interpretation-section">
            <h3>Tu pregunta:</h3>
            <p className="question-text">{reading.question}</p>
          </div>
          
          <div className="interpretation-section">
            <h3>Interpretación:</h3>
            <div className="interpretation-text">
              {reading.interpretation.split('\n\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>

      <button 
        onClick={(e) => {
          console.log('Button clicked');
          onNewReading(e);
        }} 
        className="new-reading-button"
      >
        Nueva Consulta
      </button>
    </div>
  );
};

export default ReadingResult; 